if (!customElements.get('cart-terms-agreement')) {
  customElements.define(
    'cart-terms-agreement',
    class CartTermsAgreement extends HTMLElement {
      connectedCallback() {
        this.checkbox = this.querySelector('input[type="checkbox"]');
        this.messageEl = this.querySelector('[data-terms-message]');
        // Toggle state is scoped to the enclosing cart so multiple carts
        // (e.g. page + drawer) do not interfere with one another.
        this.scope = this.closest('main-cart') || this.closest('.cart') || document;

        if (!this.checkbox) return;

        this.onChange = this.onChange.bind(this);
        this.onCheckoutAttempt = this.onCheckoutAttempt.bind(this);
        this.onPageShow = this.onPageShow.bind(this);

        this.checkbox.addEventListener('change', this.onChange);

        // Guard against an accidental submit while the button is disabled
        // (covers keyboard / programmatic activation paths as well).
        this.getCheckoutButtons().forEach((button) => {
          button.addEventListener('click', this.onCheckoutAttempt);
        });

        // Agreement is a deliberate, per-checkout action: never persist it
        // across navigation. The browser may restore the checkbox to its
        // previous "checked" state (including from the back/forward cache),
        // so we force it back to unchecked and re-sync the button.
        window.addEventListener('pageshow', this.onPageShow);

        this.reset();
      }

      disconnectedCallback() {
        window.removeEventListener('pageshow', this.onPageShow);
      }

      onPageShow() {
        // Runs on initial load and on back/forward (bfcache) restores, where
        // connectedCallback does not fire again. Always reset to unchecked.
        this.reset();
      }

      reset() {
        if (this.checkbox) this.checkbox.checked = false;
        this.hideMessage();
        this.update();
      }

      getCheckoutButtons() {
        return Array.from(this.scope.querySelectorAll('button[name="checkout"]'));
      }

      getExpressCheckout() {
        return this.scope.querySelector('.additional-checkout-buttons');
      }

      get agreed() {
        return Boolean(this.checkbox && this.checkbox.checked);
      }

      onChange() {
        this.update();
      }

      onCheckoutAttempt(event) {
        if (!this.agreed) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.showMessage();
        }
      }

      showMessage() {
        if (this.messageEl) this.messageEl.hidden = false;
        this.classList.add('cart-terms-agreement--invalid');
      }

      hideMessage() {
        if (this.messageEl) this.messageEl.hidden = true;
        this.classList.remove('cart-terms-agreement--invalid');
      }

      update() {
        const agreed = this.agreed;

        this.getCheckoutButtons().forEach((button) => {
          button.disabled = !agreed;
          button.setAttribute('aria-disabled', String(!agreed));
        });

        const express = this.getExpressCheckout();
        if (express) {
          express.classList.toggle('is-checkout-disabled', !agreed);
          express.setAttribute('aria-disabled', String(!agreed));
        }

        this.classList.toggle('cart-terms-agreement--agreed', agreed);
        if (agreed) this.hideMessage();
      }
    }
  );
}
